/**
 * Header Navigation Module
 * PC版: メガメニュー（マウスオーバーで表示）
 * SP版: アコーディオン（クリックで開閉）
 */
export class HeaderNav {
  constructor() {
    this.trigger = document.querySelector('.js-hamburger__trigger');
    this.body = document.body;
    this.breakpoint = 960; // PC版のブレークポイント
    this.isOpen = false;
    this.clickHandler = null;
    this.resizeHandler = null;
    this.wasSP = this.isSP(); // 前の状態を保存
    
    this.init();
  }
  
  /**
   * SP版かどうかを判定
   */
  isSP() {
    return window.innerWidth < this.breakpoint;
  }
  
  /**
   * 初期化
   */
  init() {
    if (!this.trigger) {
      return;
    }
    
    // 既存のイベントリスナーを削除
    this.removeEventListeners();
    
    // リサイズハンドラーを設定
    this.resizeHandler = () => {
      const isSPNow = this.isSP();
      
      // PC版に切り替わった場合、メニューを閉じる
      if (this.wasSP && !isSPNow && this.isOpen) {
        this.closeMenu();
      }
      
      // PC/SPが切り替わった場合、再初期化
      if (this.wasSP !== isSPNow) {
        this.wasSP = isSPNow;
        this.setupEventListeners();
      }
    };
    
    window.addEventListener('resize', this.resizeHandler);
    
    // イベントリスナーを設定
    this.setupEventListeners();
  }
  
  /**
   * イベントリスナーを設定
   */
  setupEventListeners() {
    if (!this.trigger) {
      return;
    }
    
    // SP版でのみ動作
    if (!this.isSP()) {
      return;
    }
    
    // ハンバーガーボタンのクリックイベント
    this.clickHandler = (e) => {
      e.preventDefault();
      
      // SP版でのみ動作
      if (!this.isSP()) {
        return;
      }
      
      this.toggleMenu();
    };
    
    this.trigger.addEventListener('click', this.clickHandler);
  }
  
  /**
   * イベントリスナーを削除
   */
  removeEventListeners() {
    if (this.clickHandler && this.trigger) {
      this.trigger.removeEventListener('click', this.clickHandler);
      this.clickHandler = null;
    }
    
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }
  }
  
  /**
   * メニューの開閉を切り替え
   */
  toggleMenu() {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  
  /**
   * メニューを開く
   */
  openMenu() {
    if (!this.isSP()) {
      return;
    }
    
    this.isOpen = true;
    this.body.classList.add('is-hamburger-open');
    // スクロール無効化
    this.body.style.overflow = 'hidden';
  }
  
  /**
   * メニューを閉じる
   */
  closeMenu() {
    this.isOpen = false;
    this.body.classList.remove('is-hamburger-open');
    // スクロール有効化
    this.body.style.overflow = '';
  }
}
